import React from 'react';
import PropTypes from 'prop-types';

import useTheme from '@material-ui/core/styles/useTheme';
import { useIntl } from 'react-intl';
import RequestActionButton from './RequestActionButton';

const ToBeHiredRequestActionButton = ({
  className,
  onClick,
  label,
  size,
  variant,
  overflow,
  disabled = false
}) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <RequestActionButton
      className={className}
      paletteClass={theme.palette.resourceRequest.toBeHired}
      label={
        label ||
        intl.formatMessage({ id: 'resourceAssignmentDialog.toBeHired' })
      }
      onClick={onClick}
      size={size}
      variant={variant}
      overflow={overflow}
      disabled={disabled}
    />
  );
};

ToBeHiredRequestActionButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  overflow: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default ToBeHiredRequestActionButton;
